import styled from "styled-components";
import colors from "css/colors";

export const Container = styled.div`
  background-color: ${colors.WHITE};
  margin: 28px;
  padding: 28px;
`;
